precision highp float;

uniform sampler2D tDiffuse;

varying vec2 vUv;

#pragma glslify: dither = require(glsl-dither/4x4)

void main() {
  vec4 texel = texture2D(tDiffuse, vUv);

  gl_FragColor = texel;
  gl_FragColor.rgb = dither(gl_FragCoord.xy, texel.rgb);
}